import gql from "graphql-tag";
import type { ApolloClient } from "@apollo/client";
import type { DocumentNode } from "graphql";

import type {
  AdminGetContributionAbilityQuery,
  AdminGetContributionAbilityQueryVariables,
  AdminUpdateUserProfileMutation,
  AdminUpdateUserProfileMutationVariables,
  AdvanceYellowPathJourneyMutation,
  AdvanceYellowPathJourneyMutationVariables,
  ApprovePayrollIntegrationSetupMutation,
  ApprovePayrollIntegrationSetupMutationVariables,
  BusinessRegistrationUpdateInput,
  CompaniesQuery,
  CompaniesQueryVariables,
  CompanyByIdQuery,
  CompanyByIdQueryVariables,
  CreateCustomReportMutation,
  CreateCustomReportMutationVariables,
  CreateInvoiceForCompanyMutation,
  CreateInvoiceForCompanyMutationVariables,
  CreateManualBankLinkMutation,
  CreateManualBankLinkMutationVariables,
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables,
  CustomReportInput,
  DisableCompanyMutation,
  DisableCompanyMutationVariables,
  EnableCompanyMutation,
  EnableCompanyMutationVariables,
  EnableFeatureForCompanyMutation,
  EnableFeatureForCompanyMutationVariables,
  EnableFeaturesForCompanyMutation,
  EnableFeaturesForCompanyMutationVariables,
  FreezeEmployerMutation,
  FreezeEmployerMutationVariables,
  GetAdminReportLinkQuery,
  GetAdminReportLinkQueryVariables,
  GetAdminReportsQuery,
  GetAdminReportsQueryVariables,
  GetAlloyApplicationQuery,
  GetAlloyApplicationQueryVariables,
  GetApprovalRequestQuery,
  GetApprovalRequestQueryVariables,
  GetApprovalRequestsQuery,
  GetApprovalRequestsQueryVariables,
  GetBillingDetailsForCompanyQuery,
  GetBillingDetailsForCompanyQueryVariables,
  GetCompanyAdminsAndAgentsQuery,
  GetCompanyAdminsAndAgentsQueryVariables,
  GetCompanyKybDataQuery,
  GetCompanyKybDataQueryVariables,
  GetCompanyMemberQuery,
  GetCompanyMemberQueryVariables,
  GetCustomReportsQuery,
  GetCustomReportsQueryVariables,
  GetDocumentsWithGetUserByIdQuery,
  GetDocumentsWithGetUserByIdQueryVariables,
  GetEmployerCrmLinkQuery,
  GetEmployerCrmLinkQueryVariables,
  GetEmployerGroupsByCompanyIdQuery,
  GetEmployerGroupsByCompanyIdQueryVariables,
  GetEmployerOrdersQuery,
  GetEmployerOrdersQueryVariables,
  GetEntityLimitsQuery,
  GetEntityLimitsQueryVariables,
  GetGroupsAndBanksQuery,
  GetGroupsAndBanksQueryVariables,
  GetKybDocumentTypesQuery,
  GetKybDocumentTypesQueryVariables,
  GetKybStatusForCompanyQuery,
  GetKybStatusForCompanyQueryVariables,
  GetKybStatusQuery,
  GetKybStatusQueryVariables,
  GetLastWorkflowStepQuery,
  GetLastWorkflowStepQueryVariables,
  GetMembersForCompanyQuery,
  GetMembersForCompanyQueryVariables,
  GetOrganizationForCompanyQuery,
  GetOrganizationForCompanyQueryVariables,
  GetPaginatedCompaniesQuery,
  GetPaginatedCompaniesQueryVariables,
  GetPaginatedWorkflowsQuery,
  GetPaginatedWorkflowsQueryVariables,
  GetPaychexUsersQuery,
  GetPaychexUsersQueryVariables,
  GetPaychexUsersReportQuery,
  GetPaychexUsersReportQueryVariables,
  GetPayrollsQuery,
  GetPayrollsQueryVariables,
  GetPendingAndLinkedEmployersQuery,
  GetPendingAndLinkedEmployersQueryVariables,
  GetPricingSheetQuery,
  GetPricingSheetQueryVariables,
  GetProductFeaturesQuery,
  GetProductFeaturesQueryVariables,
  GetReportCsvQuery,
  GetReportCsvQueryVariables,
  GetReportTypesQuery,
  GetReportTypesQueryVariables,
  GetReportsStatusQuery,
  GetReportsStatusQueryVariables,
  GetSecurityDetailsQuery,
  GetSecurityDetailsQueryVariables,
  GetTakeRateForCompanyQuery,
  GetTakeRateForCompanyQueryVariables,
  GetUserByEmailQuery,
  GetUserByEmailQueryVariables,
  GetUserByIdQuery,
  GetUserByIdQueryVariables,
  GetUserDetailsQuery,
  GetUserDetailsQueryVariables,
  GetUserTransactionsQuery,
  GetUserTransactionsQueryVariables,
  LinkEmployerToCrmMutation,
  LinkEmployerToCrmMutationVariables,
  LiquidateUserAccountMutation,
  LiquidateUserAccountMutationVariables,
  LockUserMutation,
  LockUserMutationVariables,
  MemberFieldEditInput,
  MigrateEmployeesForCompanyMutation,
  MigrateEmployeesForCompanyMutationVariables,
  PartiallyDisburseUserAccountMutation,
  PartiallyDisburseUserAccountMutationVariables,
  RegisterKybUserMutation,
  RegisterKybUserMutationVariables,
  RemoveCompanyMemberMutation,
  RemoveCompanyMemberMutationVariables,
  ReopenUserAccountMutation,
  ReopenUserAccountMutationVariables,
  RequestBusinessRegistrationUpdateMutation,
  RequestBusinessRegistrationUpdateMutationVariables,
  RequestMemberFieldEditMutation,
  RequestMemberFieldEditMutationVariables,
  RequirePortfolioUpdateMutation,
  RequirePortfolioUpdateMutationVariables,
  ResetUserStateMutation,
  ResetUserStateMutationVariables,
  RestartWorkflowMutation,
  RestartWorkflowMutationVariables,
  RetryYellowPathDocumentUploadMutation,
  RetryYellowPathDocumentUploadMutationVariables,
  SearchUsersQuery,
  SearchUsersQueryVariables,
  SetApprovalStatusMutation,
  SetApprovalStatusMutationVariables,
  StartKybMutation,
  StartKybMutationVariables,
  SubmitKybBusinessDocumentsMutation,
  SubmitKybBusinessDocumentsMutationVariables,
  SubmitKybMemberDocumentsMutation,
  SubmitKybMemberDocumentsMutationVariables,
  SyncCrmMutation,
  SyncCrmMutationVariables,
  UnfreezeEmployerMutation,
  UnfreezeEmployerMutationVariables,
  UnlinkEmployerToCrmMutation,
  UnlinkEmployerToCrmMutationVariables,
  UnlockUserMutation,
  UnlockUserMutationVariables,
  UnprocessedPayrollsQuery,
  UnprocessedPayrollsQueryVariables,
  UpdateBillingTypeMutation,
  UpdateBillingTypeMutationVariables,
  UpdateCompanyBillingContactMutation,
  UpdateCompanyBillingContactMutationVariables,
  UpdateCompanyInfoMutation,
  UpdateCompanyInfoMutationVariables,
  UpdateCompanyKybInfoMutation,
  UpdateCompanyKybInfoMutationVariables,
  UpdateEntityLimitMutation,
  UpdateEntityLimitMutationVariables,
  UpdateUserEmailInput,
  UpdateUserEmailMutation,
  UpdateUserEmailMutationVariables,
  UpdateUserKycInput,
  UpdateUserKycMutation,
  UpdateUserKycMutationVariables,
  UploadEmployeeDocumentForEmployerMutation,
  UploadEmployeeDocumentForEmployerMutationVariables,
  UserRolloversQuery,
  UserRolloversQueryVariables,
  YellowPathAppeal,
} from "types/graphql";

export function submitKYBUser(
  client: ApolloClient<object>,
  kybUserParams: RegisterKybUserMutationVariables
): Promise<RegisterKybUserMutation> {
  return new Promise((resolve, reject) => {
    const REGISTER_KYB_USER = gql`
      mutation RegisterKYBUser(
        $employerId: String
        $id: ID
        $firstName: String!
        $lastName: String!
        $email: String!
        $role: String!
        $ownershipStake: Float!
        $address1: String!
        $address2: String!
        $city: String!
        $state: String!
        $postalCode: String!
        $phone: String!
        $dob: String!
        $ssn: String!
      ) {
        registerKYBUser(
          employerId: $employerId
          id: $id
          firstName: $firstName
          lastName: $lastName
          email: $email
          role: $role
          ownershipStake: $ownershipStake
          address1: $address1
          address2: $address2
          city: $city
          state: $state
          postalCode: $postalCode
          phone: $phone
          dob: $dob
          ssn: $ssn
        ) {
          error
        }
      }
    `;
    const result = client.mutate<
      RegisterKybUserMutation,
      RegisterKybUserMutationVariables
    >({
      mutation: REGISTER_KYB_USER,
      variables: {
        employerId: kybUserParams.employerId,
        firstName: kybUserParams.firstName,
        lastName: kybUserParams.lastName,
        email: kybUserParams.email,
        role: kybUserParams.role,
        ownershipStake: kybUserParams.ownershipStake,
        address1: kybUserParams.address1,
        address2: kybUserParams.address2,
        city: kybUserParams.city,
        state: kybUserParams.state,
        postalCode: kybUserParams.postalCode,
        phone: kybUserParams.phone,
        dob: kybUserParams.dob,
        ssn: kybUserParams.ssn,
        id: kybUserParams.id,
      },
    });
    result.then(
      (response) => {
        const inBandError = response.data?.registerKYBUser?.error;
        if (inBandError) {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- string rejections surface verbatim through wrapError
          reject(inBandError);
        } else if (response.data) {
          resolve(response.data);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- pre-existing contract: rejects the raw Apollo response
          reject(response);
        }
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function submitKYB(
  client: ApolloClient<object>,
  kybEmployer: StartKybMutationVariables
): Promise<StartKybMutation> {
  return new Promise((resolve, reject) => {
    const REGISTER_KYB = gql`
      mutation StartKYB($employerId: ID!) {
        startKYB(employerId: $employerId)
      }
    `;
    const result = client.mutate<StartKybMutation, StartKybMutationVariables>({
      mutation: REGISTER_KYB,
      variables: {
        employerId: kybEmployer.employerId,
      },
    });
    result.then(
      (response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- pre-existing contract: rejects the raw Apollo response
          reject(response);
        }
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getApprovalRequest(
  client: ApolloClient<object>,
  approvalId: GetApprovalRequestQueryVariables["approvalId"]
): Promise<GetApprovalRequestQuery["getApprovalRequest"]> {
  return new Promise((resolve, reject) => {
    const APPROVAL = gql`
      query getApprovalRequest($approvalId: ID!) {
        getApprovalRequest(approvalId: $approvalId) {
          id
          entityIdentifier {
            id
            type
          }
          type {
            value
            urlPath
            label
            requiresDistinctApprovers
          }
          correlationName
          createdAt
          updatedAt
          status
          updatedBy
          createdBy
          createdByEntity {
            id
            type
          }
          reasonComment
          allReasons
          metadataItems {
            name
            value
          }
          documents {
            id
            name
            uri
            contentType
            createdAt
            updatedAt
            type
            metadata {
              downloadUrl
              contentType
              createdAt
              updatedAt
            }
          }
        }
      }
    `;
    const result = client.query<
      GetApprovalRequestQuery,
      GetApprovalRequestQueryVariables
    >({
      query: APPROVAL,
      variables: { approvalId },
    });
    result.then(
      (data) => {
        resolve(data.data.getApprovalRequest);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getUserById(
  client: ApolloClient<object>,
  userId: GetUserByIdQueryVariables["userId"]
): Promise<GetUserByIdQuery["getUserById"]> {
  return new Promise((resolve, reject) => {
    const USER = gql`
      query getUserById($userId: ID!) {
        getUserById(userId: $userId) {
          firstName
          lastName
          email
          id
          state
          yellowPathCodes {
            rejectCodes
            indeterminateCodes
            otherCodes
          }
        }
      }
    `;
    const result = client.query<GetUserByIdQuery, GetUserByIdQueryVariables>({
      query: USER,
      variables: { userId },
    });
    result.then(
      (data) => {
        resolve(data.data.getUserById);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getUserByEmail(
  client: ApolloClient<object>,
  email: GetUserByEmailQueryVariables["email"]
): Promise<GetUserByEmailQuery["getUserByEmail"]> {
  return new Promise((resolve, reject) => {
    const USER = gql`
      query getUserByEmail($email: String!) {
        getUserByEmail(email: $email) {
          firstName
          lastName
          email
          id
          state
          yellowPathCodes {
            rejectCodes
            indeterminateCodes
            otherCodes
          }
        }
      }
    `;
    const result = client.query<
      GetUserByEmailQuery,
      GetUserByEmailQueryVariables
    >({
      query: USER,
      variables: { email },
    });
    result.then(
      (data) => {
        resolve(data.data.getUserByEmail);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getUserTransactions(
  client: ApolloClient<object>,
  userId: GetUserTransactionsQueryVariables["userId"]
): Promise<GetUserTransactionsQuery["getUserTransactions"]> {
  return new Promise((resolve, reject) => {
    const TRANSACTIONS = gql`
      query getUserTransactions($userId: ID!) {
        getUserTransactions(userId: $userId) {
          memo
          status
          updatedAt
          id
          createdAt
        }
      }
    `;
    const result = client.query<
      GetUserTransactionsQuery,
      GetUserTransactionsQueryVariables
    >({
      query: TRANSACTIONS,
      variables: { userId },
    });
    result.then(
      (data) => {
        resolve(data.data.getUserTransactions);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function setApproval(
  client: ApolloClient<object>,
  approvalParams: SetApprovalStatusMutationVariables["approvalParams"]
): Promise<SetApprovalStatusMutation["setApprovalStatus"] | null> {
  return new Promise((resolve, reject) => {
    const UPDATE_APPROVAL = gql`
      mutation setApprovalStatus($approvalParams: ApprovalParams!) {
        setApprovalStatus(approvalParams: $approvalParams) {
          id
          type {
            value
            urlPath
            label
          }
          createdAt
          updatedAt
          status
          updatedBy
          reasonComment
          allReasons
        }
      }
    `;
    const result = client.mutate<
      SetApprovalStatusMutation,
      SetApprovalStatusMutationVariables
    >({
      mutation: UPDATE_APPROVAL,
      variables: {
        approvalParams,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.setApprovalStatus ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function lockUser(
  client: ApolloClient<object>,
  userId: LockUserMutationVariables["userId"]
): Promise<LockUserMutation["lockUser"] | null> {
  return new Promise((resolve, reject) => {
    const LOCK_USER = gql`
      mutation lockUser($userId: ID!) {
        lockUser(userId: $userId) {
          state
        }
      }
    `;
    const result = client.mutate<LockUserMutation, LockUserMutationVariables>({
      mutation: LOCK_USER,
      variables: {
        userId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.lockUser ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function unlockUser(
  client: ApolloClient<object>,
  userId: UnlockUserMutationVariables["userId"]
): Promise<UnlockUserMutation["unlockUser"] | null> {
  return new Promise((resolve, reject) => {
    const UNLOCK_USER = gql`
      mutation unlockUser($userId: ID!) {
        unlockUser(userId: $userId) {
          state
        }
      }
    `;
    const result = client.mutate<
      UnlockUserMutation,
      UnlockUserMutationVariables
    >({
      mutation: UNLOCK_USER,
      variables: {
        userId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.unlockUser ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getAllCompanies(
  client: ApolloClient<object>
): Promise<CompaniesQuery["companies"]> {
  return new Promise((resolve, reject) => {
    const COMPANIES = gql`
      query companies {
        companies {
          name
          id
          deleted
          createdAt
          currentState
        }
      }
    `;
    const result = client.query<CompaniesQuery, CompaniesQueryVariables>({
      query: COMPANIES,
    });
    result.then(
      (data) => {
        resolve(data.data.companies);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

// get company details
export function getCompany(
  client: ApolloClient<object>,
  companyId: CompanyByIdQueryVariables["companyId"]
): Promise<CompanyByIdQuery["companyById"]> {
  return new Promise((resolve, reject) => {
    const GET_COMPANY = gql`
      query companyById($companyId: ID!) {
        companyById(companyId: $companyId) {
          id
          name
          dba
          ein
          type
          naicsCode
          size
          url
          planId
          currentState
          billingType
          stripeCustomerId
          payrollIntegrationStatus
          payrollProvider
          user {
            id
            email
          }
          address {
            id
            address1
            address2
            city
            state
            postalCode
            phone
            phoneExt
            fax
          }
          registrationDate
          planTypes {
            id
            description
            name
          }
          enabledProductFeatures
          progressiveOnboardingState
          freezeDetails(companyId: $companyId) {
            status
            reason
            metadata
          }
        }
      }
    `;
    const result = client.query<CompanyByIdQuery, CompanyByIdQueryVariables>({
      query: GET_COMPANY,
      variables: { companyId },
    });
    result.then(
      (data) => {
        resolve(data.data.companyById);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getCompanyKybData(
  client: ApolloClient<object>,
  companyId: GetCompanyKybDataQueryVariables["companyId"]
): Promise<GetCompanyKybDataQuery["getCompanyKybData"]> {
  return new Promise((resolve, reject) => {
    const GET_COMPANY = gql`
      query getCompanyKybData($companyId: ID!) {
        getCompanyKybData(companyId: $companyId) {
          employerProfile {
            id
            email
            addressAlias
            address1
            address2
            city
            state
            postalCode
            businessName
            businessType
            doingBusinessAs
            naicsBusinessClassification
            ein
            website
            phone
          }
          silaWallet {
            id
            correlationId
            routingNumber
            accountNumber
            accountType
            name
            active
          }

          businessMembers {
            id
            businessMemberHandle
            role
            ownershipStake
            state
            memberProfile {
              legalName
              firstName
              lastName
              alias
              email
              phoneNumber
              ssn
              citizenshipCountry
              birthCountry
              permanentResident
              dob
              address1
              address2
              city
              state
              postalCode
              maritalStatus
              numberOfDependents
              employeeId
              phone
            }
          }
          businessDocuments {
            id
            uri
            contentType
            name
            metadata {
              batchUploadCount
            }
            type
          }
          documents {
            id
            uri
            contentType
            metadata {
              batchUploadCount
            }
            type
          }
          businessMemberDocuments {
            memberId
            id
            correlationId
            uri
            contentType
            name
            createdAt
            metadata {
              batchUploadCount
            }
            type
          }
        }
      }
    `;
    const result = client.query<
      GetCompanyKybDataQuery,
      GetCompanyKybDataQueryVariables
    >({
      query: GET_COMPANY,
      variables: { companyId },
    });
    result.then(
      (data) => {
        resolve(data.data.getCompanyKybData);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

// Update company profile
export function updateCompanyKYBInfo(
  client: ApolloClient<object>,
  companyDetails: UpdateCompanyKybInfoMutationVariables
): Promise<UpdateCompanyKybInfoMutation["updateCompanyKYBInfo"] | null> {
  return new Promise((resolve, reject) => {
    const UPDATE_COMPANY = gql`
      mutation updateCompanyKYBInfo(
        $id: ID!
        $name: String
        $dba: String
        $ein: String
        $type: String
        $naicsCode: String
        $size: String
        $url: String
        $addressId: ID
        $address1: String
        $address2: String
        $city: String
        $state: String
        $phone: String
        $phoneExt: String
        $postalCode: String
        $fax: String
        $registrationDate: String
      ) {
        updateCompanyKYBInfo(
          id: $id
          name: $name
          dba: $dba
          ein: $ein
          type: $type
          naicsCode: $naicsCode
          size: $size
          url: $url
          addressId: $addressId
          address1: $address1
          address2: $address2
          city: $city
          state: $state
          phone: $phone
          phoneExt: $phoneExt
          postalCode: $postalCode
          fax: $fax
          registrationDate: $registrationDate
        ) {
          company {
            id
            name
            dba
            ein
            type
            naicsCode
            size
            url
            limits {
              key
              value
            }
            address {
              id
              address1
              address2
              city
              state
              postalCode
              phone
              phoneExt
              fax
            }
          }
          error
        }
      }
    `;

    const result = client.mutate<
      UpdateCompanyKybInfoMutation,
      UpdateCompanyKybInfoMutationVariables
    >({
      mutation: UPDATE_COMPANY,
      variables: {
        id: companyDetails.id,
        name: companyDetails.name,
        dba: companyDetails.dba,
        ein: companyDetails.ein,
        type: companyDetails.type,
        naicsCode: companyDetails.naicsCode,
        size: companyDetails.size,
        url: companyDetails.url,
        addressId: companyDetails.addressId,
        address1: companyDetails.address1,
        address2: companyDetails.address2,
        city: companyDetails.city,
        state: companyDetails.state,
        phone: companyDetails.phone,
        phoneExt: companyDetails.phoneExt,
        postalCode: companyDetails.postalCode,
        fax: companyDetails.fax,
        registrationDate: companyDetails.registrationDate,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.updateCompanyKYBInfo ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function updateCompanyInfo(
  client: ApolloClient<object>,
  companyDetails: UpdateCompanyInfoMutationVariables
): Promise<UpdateCompanyInfoMutation["updateCompanyInfo"] | null> {
  return new Promise((resolve, reject) => {
    const UPDATE_COMPANY = gql`
      mutation updateCompanyInfo(
        $id: ID!
        $name: String
        $dba: String
        $ein: String
        $type: String
        $naicsCode: String
        $size: String
        $url: String
        $addressId: ID
        $address1: String
        $address2: String
        $city: String
        $state: String
        $phone: String
        $phoneExt: String
        $postalCode: String
        $fax: String
        $registrationDate: String
      ) {
        updateCompanyInfo(
          id: $id
          name: $name
          dba: $dba
          ein: $ein
          type: $type
          naicsCode: $naicsCode
          size: $size
          url: $url
          addressId: $addressId
          address1: $address1
          address2: $address2
          city: $city
          state: $state
          phone: $phone
          phoneExt: $phoneExt
          postalCode: $postalCode
          fax: $fax
          registrationDate: $registrationDate
        ) {
          company {
            id
            name
            dba
            ein
            type
            naicsCode
            size
            url
            limits {
              key
              value
            }
            address {
              id
              address1
              address2
              city
              state
              postalCode
              phone
              phoneExt
              fax
            }
          }
          error
        }
      }
    `;

    const result = client.mutate<
      UpdateCompanyInfoMutation,
      UpdateCompanyInfoMutationVariables
    >({
      mutation: UPDATE_COMPANY,
      variables: {
        id: companyDetails.id,
        name: companyDetails.name,
        dba: companyDetails.dba,
        ein: companyDetails.ein,
        type: companyDetails.type,
        naicsCode: companyDetails.naicsCode,
        size: companyDetails.size,
        url: companyDetails.url,
        addressId: companyDetails.addressId,
        address1: companyDetails.address1,
        address2: companyDetails.address2,
        city: companyDetails.city,
        state: companyDetails.state,
        phone: companyDetails.phone,
        phoneExt: companyDetails.phoneExt,
        postalCode: companyDetails.postalCode,
        fax: companyDetails.fax,
        registrationDate: companyDetails.registrationDate,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.updateCompanyInfo ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getComplianceReports(
  client: ApolloClient<object>
): Promise<GetAdminReportsQuery["getAdminReports"]> {
  return new Promise((resolve, reject) => {
    const REPORTS = gql`
      query getAdminReports {
        getAdminReports {
          reportType
          reportHistory
        }
      }
    `;
    const result = client.query<
      GetAdminReportsQuery,
      GetAdminReportsQueryVariables
    >({
      query: REPORTS,
      variables: {},
    });
    result.then(
      (data) => {
        resolve(data.data.getAdminReports);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getComplianceReportLink(
  client: ApolloClient<object>,
  reportType: GetAdminReportLinkQueryVariables["reportType"],
  reportDate: GetAdminReportLinkQueryVariables["reportDate"]
): Promise<GetAdminReportLinkQuery["getAdminReportLink"]> {
  return new Promise((resolve, reject) => {
    const REPORT_LINK = gql`
      query getAdminReportLink($reportType: String!, $reportDate: String!) {
        getAdminReportLink(reportType: $reportType, reportDate: $reportDate) {
          uri
          expiresAfter
        }
      }
    `;
    const result = client.query<
      GetAdminReportLinkQuery,
      GetAdminReportLinkQueryVariables
    >({
      query: REPORT_LINK,
      variables: {
        reportType,
        reportDate,
      },
    });
    result.then(
      (data) => {
        resolve(data.data.getAdminReportLink);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getApprovalRequests(
  client: ApolloClient<object>,
  status: GetApprovalRequestsQueryVariables["status"]
): Promise<GetApprovalRequestsQuery["getApprovalRequests"]> {
  return new Promise((resolve, reject) => {
    const APPROVALS = gql`
      query getApprovalRequests($status: ApprovalStatus) {
        getApprovalRequests(status: $status) {
          id
          entityIdentifier {
            id
            type
          }
          type {
            value
            urlPath
            label
          }
          correlationName
          createdAt
          updatedAt
          status
          updatedBy
          reasonComment
          allReasons
          metadataItems {
            name
            value
          }
        }
      }
    `;
    client
      .query<GetApprovalRequestsQuery, GetApprovalRequestsQueryVariables>({
        query: APPROVALS,
        variables: { status },
      })
      .then(
        (data) => {
          resolve(data.data.getApprovalRequests);
        },
        (error: Error) => {
          reject(error);
        }
      );
  });
}

export function getUserReviewDocuments(
  client: ApolloClient<object>,
  userId: GetDocumentsWithGetUserByIdQueryVariables["userId"]
): Promise<GetDocumentsWithGetUserByIdQuery["getUserById"]> {
  return new Promise((resolve, reject) => {
    const GET_REVIEW_DOCUMENTS = gql`
      query getDocumentsWithGetUserById($userId: ID!) {
        getUserById(userId: $userId) {
          id
          email
          username
          documents {
            id
            uri
            contentType
            metadata {
              batchUploadCount
            }
            type
          }
        }
      }
    `;
    client
      .query<
        GetDocumentsWithGetUserByIdQuery,
        GetDocumentsWithGetUserByIdQueryVariables
      >({
        query: GET_REVIEW_DOCUMENTS,
        variables: { userId },
      })
      .then(
        (data) => {
          resolve(data.data.getUserById);
        },
        (errors: Error) => {
          reject(errors);
        }
      );
  });
}

type YellowPathAppealAction = "APPROVE" | "APPROVE_ATTESTATION" | "DENY";
type YellowPathAppealArgs = [
  client: ApolloClient<object>,
  yellowPathAppeal: YellowPathAppeal,
];

export function approveYellowPathAppeal(...requestData: YellowPathAppealArgs) {
  return handleYellowPathAppeal("APPROVE", ...requestData);
}

export function approveYellowPathAttestation(
  ...requestData: YellowPathAppealArgs
) {
  return handleYellowPathAppeal("APPROVE_ATTESTATION", ...requestData);
}

export function denyYellowPathAppeal(...requestData: YellowPathAppealArgs) {
  return handleYellowPathAppeal("DENY", ...requestData);
}

function handleYellowPathAppeal(
  actionType: YellowPathAppealAction,
  client: ApolloClient<object>,
  yellowPathAppeal: YellowPathAppeal
): Promise<unknown> {
  const actions = {
    APPROVE: "approveYellowPathAppeal",
    APPROVE_ATTESTATION: "approveYellowPathAttestation",
    DENY: "denyYellowPathAppeal",
  };
  const mutation = getAppealReasonActionMutation(actionType);
  const responseFieldName = actions[actionType];
  return new Promise((resolve, reject) => {
    client
      // the three appeal mutations return different result shapes, indexed
      // dynamically by `responseFieldName` — typed as a Record at the boundary
      .mutate<Record<string, unknown>>({
        mutation,
        variables: { yellowPathAppeal },
      })
      .then(
        (data) => {
          resolve(data.data?.[responseFieldName] ?? null);
        },
        (errors: Error) => {
          reject(errors);
        }
      );
  });
}

export function retryYellowPathAppeal(
  client: ApolloClient<object>,
  { userId }: RetryYellowPathDocumentUploadMutationVariables
): Promise<
  RetryYellowPathDocumentUploadMutation["retryYellowPathDocumentUpload"]
> {
  return new Promise((resolve, reject) => {
    const mutation = gql`
      mutation retryYellowPathDocumentUpload($userId: ID!) {
        retryYellowPathDocumentUpload(userId: $userId)
      }
    `;
    client
      .mutate<
        RetryYellowPathDocumentUploadMutation,
        RetryYellowPathDocumentUploadMutationVariables
      >({
        mutation,
        variables: { userId },
      })
      .then(
        (data) => {
          resolve(data.data?.retryYellowPathDocumentUpload ?? null);
        },
        (errors: Error) => {
          reject(errors);
        }
      );
  });
}

function getAppealReasonActionMutation(
  actionType: YellowPathAppealAction
): DocumentNode {
  const mutations = {
    APPROVE: gql`
      mutation approveYellowPathAppeal($yellowPathAppeal: YellowPathAppeal!) {
        approveYellowPathAppeal(yellowPathAppeal: $yellowPathAppeal)
      }
    `,
    DENY: gql`
      mutation denyYellowPathAppeal($yellowPathAppeal: YellowPathAppeal!) {
        denyYellowPathAppeal(yellowPathAppeal: $yellowPathAppeal)
      }
    `,
    APPROVE_ATTESTATION: gql`
      mutation approveYellowPathAttestation(
        $yellowPathAppeal: YellowPathAppeal!
      ) {
        approveYellowPathAttestation(yellowPathAppeal: $yellowPathAppeal)
      }
    `,
  };
  return mutations[actionType];
}

export function requirePortfolioUpdateRequest(
  client: ApolloClient<object>,
  userId: RequirePortfolioUpdateMutationVariables["userId"]
): Promise<RequirePortfolioUpdateMutation["requirePortfolioUpdate"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation requirePortfolioUpdate($userId: ID!) {
        requirePortfolioUpdate(userId: $userId) {
          state
        }
      }
    `;
    const result = client.mutate<
      RequirePortfolioUpdateMutation,
      RequirePortfolioUpdateMutationVariables
    >({
      mutation: request,
      variables: {
        userId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.requirePortfolioUpdate ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function enableFeatureForCompany(
  client: ApolloClient<object>,
  { companyId, featureId }: EnableFeatureForCompanyMutationVariables
): Promise<EnableFeatureForCompanyMutation["enableFeatureForCompany"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation enableFeatureForCompany($companyId: ID!, $featureId: ID!) {
        enableFeatureForCompany(companyId: $companyId, featureId: $featureId)
      }
    `;
    const result = client.mutate<
      EnableFeatureForCompanyMutation,
      EnableFeatureForCompanyMutationVariables
    >({
      mutation: request,
      variables: {
        companyId,
        featureId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.enableFeatureForCompany ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getEmployerGroupsByCompanyIdRequest(
  client: ApolloClient<object>,
  companyId: GetEmployerGroupsByCompanyIdQueryVariables["companyId"]
): Promise<GetEmployerGroupsByCompanyIdQuery["getEmployerGroupsByCompanyId"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getEmployerGroupsByCompanyId($companyId: ID!) {
        getEmployerGroupsByCompanyId(id: $companyId) {
          id
          name
          planType
        }
      }
    `;
    client
      .query<
        GetEmployerGroupsByCompanyIdQuery,
        GetEmployerGroupsByCompanyIdQueryVariables
      >({
        query: REQUEST,
        variables: { companyId },
      })
      .then(
        (data) => {
          resolve(data.data.getEmployerGroupsByCompanyId);
        },
        (errors: Error) => {
          reject(errors);
        }
      );
  });
}

export function uploadEmployeesDocumentForEmployerRequest(
  client: ApolloClient<object>,
  groupId: UploadEmployeeDocumentForEmployerMutationVariables["groupId"],
  file: UploadEmployeeDocumentForEmployerMutationVariables["file"],
  companyId: UploadEmployeeDocumentForEmployerMutationVariables["companyId"]
): Promise<
  UploadEmployeeDocumentForEmployerMutation["uploadEmployeeDocumentForEmployer"]
> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation uploadEmployeeDocumentForEmployer(
        $companyId: ID!
        $groupId: ID!
        $file: DocumentInput!
      ) {
        uploadEmployeeDocumentForEmployer(
          companyId: $companyId
          groupId: $groupId
          file: $file
        ) {
          id
          documentId
          message
          status
          groupId
          filename
          group {
            planType
            name
          }
        }
      }
    `;
    const result = client.mutate<
      UploadEmployeeDocumentForEmployerMutation,
      UploadEmployeeDocumentForEmployerMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        companyId,
        groupId,
        file,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.uploadEmployeeDocumentForEmployer ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function enableFeaturesForCompany(
  client: ApolloClient<object>,
  { companyId, featureIds }: EnableFeaturesForCompanyMutationVariables
): Promise<
  EnableFeaturesForCompanyMutation["enableFeaturesForCompany"] | null
> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation enableFeaturesForCompany($companyId: ID!, $featureIds: [Int!]) {
        enableFeaturesForCompany(companyId: $companyId, featureIds: $featureIds)
      }
    `;
    const result = client.mutate<
      EnableFeaturesForCompanyMutation,
      EnableFeaturesForCompanyMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        companyId,
        featureIds,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.enableFeaturesForCompany ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getProductFeatures(
  client: ApolloClient<object>
): Promise<GetProductFeaturesQuery["getProductFeatures"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getProductFeatures {
        getProductFeatures {
          id
          name
          description
        }
      }
    `;
    const result = client.query<
      GetProductFeaturesQuery,
      GetProductFeaturesQueryVariables
    >({
      query: REQUEST,
      variables: {},
    });
    result.then(
      (data) => {
        resolve(data.data.getProductFeatures);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getPaginatedCompanies(
  client: ApolloClient<object>,
  { limit, offset, search, stateFilter }: GetPaginatedCompaniesQueryVariables
): Promise<GetPaginatedCompaniesQuery["getPaginatedCompanies"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPaginatedCompanies(
        $limit: Int!
        $offset: Int!
        $search: String
        $stateFilter: String
      ) {
        getPaginatedCompanies(
          limit: $limit
          offset: $offset
          search: $search
          stateFilter: $stateFilter
        ) {
          count
          rows {
            name
            id
            deleted
            createdAt
            currentState
            dba
          }
        }
      }
    `;
    const result = client.query<
      GetPaginatedCompaniesQuery,
      GetPaginatedCompaniesQueryVariables
    >({
      query: REQUEST,
      variables: {
        limit,
        offset,
        search,
        stateFilter,
      },
    });
    result.then(
      (data) => {
        resolve(data.data.getPaginatedCompanies);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function linkBank(
  client: ApolloClient<object>,
  {
    accountType,
    accountNumber,
    routingNumber,
    companyId,
    bankName,
  }: CreateManualBankLinkMutationVariables
): Promise<CreateManualBankLinkMutation> {
  return new Promise((resolve, reject) => {
    const MUTATION = gql`
      mutation createManualBankLink(
        $companyId: ID!
        $accountNumber: String!
        $routingNumber: String!
        $bankName: String!
        $accountType: BankAccountType
      ) {
        createManualBankLink(
          companyId: $companyId
          accountNumber: $accountNumber
          routingNumber: $routingNumber
          accountType: $accountType
          bankName: $bankName
        )
      }
    `;
    const result = client.mutate<
      CreateManualBankLinkMutation,
      CreateManualBankLinkMutationVariables
    >({
      mutation: MUTATION,
      variables: {
        accountType,
        accountNumber,
        bankName,
        routingNumber,
        companyId,
      },
    });
    result.then(
      (response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- pre-existing contract: rejects the raw Apollo response
          reject(response);
        }
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getTakeRateForCompany(
  client: ApolloClient<object>,
  companyId: GetTakeRateForCompanyQueryVariables["companyId"]
): Promise<GetTakeRateForCompanyQuery["getTakeRateForCompany"]> {
  return new Promise((resolve, reject) => {
    const GET_TAKE_RATE_EMPLOYEES = gql`
      query getTakeRateForCompany($companyId: ID!) {
        getTakeRateForCompany(companyId: $companyId) {
          notStarted
          opening
          enrolled
        }
      }
    `;
    const result = client.query<
      GetTakeRateForCompanyQuery,
      GetTakeRateForCompanyQueryVariables
    >({
      query: GET_TAKE_RATE_EMPLOYEES,
      variables: { companyId },
      fetchPolicy: "network-only",
    });
    result.then(
      (response) => {
        resolve(response.data.getTakeRateForCompany);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getCompanyMembers(
  client: ApolloClient<object>,
  companyId: GetMembersForCompanyQueryVariables["companyId"]
): Promise<GetMembersForCompanyQuery["getMembersForCompany"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getMembersForCompany($companyId: ID!) {
        getMembersForCompany(companyId: $companyId) {
          id
          businessMemberHandle
          role
          ownershipStake
          state
          memberProfile {
            legalName
            firstName
            lastName
            alias
            email
            phoneNumber
            ssn
            citizenshipCountry
            birthCountry
            permanentResident
            dob
            address1
            address2
            city
            state
            postalCode
            maritalStatus
            numberOfDependents
            employeeId
            phone
          }
        }
      }
    `;
    const result = client.query<
      GetMembersForCompanyQuery,
      GetMembersForCompanyQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
      fetchPolicy: "network-only",
    });
    result.then(
      (response) => {
        resolve(response.data.getMembersForCompany);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getMember(
  client: ApolloClient<object>,
  { companyId, memberId }: GetCompanyMemberQueryVariables
): Promise<GetCompanyMemberQuery["getCompanyMember"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getCompanyMember($companyId: ID!, $memberId: ID!) {
        getCompanyMember(companyId: $companyId, memberId: $memberId) {
          id
          businessMemberHandle
          role
          ownershipStake
          state
          memberProfile {
            legalName
            firstName
            lastName
            alias
            email
            phoneNumber
            ssn
            citizenshipCountry
            birthCountry
            permanentResident
            dob
            address1
            address2
            city
            state
            postalCode
            maritalStatus
            numberOfDependents
            employeeId
            phone
          }
        }
      }
    `;
    const result = client.query<
      GetCompanyMemberQuery,
      GetCompanyMemberQueryVariables
    >({
      query: REQUEST,
      variables: { companyId, memberId },
      fetchPolicy: "network-only",
    });
    result.then(
      (response) => {
        resolve(response.data.getCompanyMember);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function removeCompanyMember(
  client: ApolloClient<object>,
  { companyId, memberId }: RemoveCompanyMemberMutationVariables
): Promise<RemoveCompanyMemberMutation> {
  return new Promise((resolve, reject) => {
    const MUTATION = gql`
      mutation removeCompanyMember($companyId: ID!, $memberId: ID!) {
        removeCompanyMember(companyId: $companyId, memberId: $memberId)
      }
    `;
    const result = client.mutate<
      RemoveCompanyMemberMutation,
      RemoveCompanyMemberMutationVariables
    >({
      mutation: MUTATION,
      variables: {
        companyId,
        memberId,
      },
    });
    result.then(
      (response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- pre-existing contract: rejects the raw Apollo response
          reject(response);
        }
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function createOrganization(
  client: ApolloClient<object>,
  { companyId, name }: CreateOrganizationMutationVariables
): Promise<CreateOrganizationMutation["createOrganization"]> {
  return new Promise((resolve, reject) => {
    const MUTATION = gql`
      mutation createOrganization($companyId: ID!, $name: String!) {
        createOrganization(companyId: $companyId, name: $name) {
          organization {
            id
            name
            companyLimit
            linkedCompanies {
              id
              name
              dba
              ein
              type
              size
              url
              planId
              currentState
            }
          }
        }
      }
    `;
    const result = client.mutate<
      CreateOrganizationMutation,
      CreateOrganizationMutationVariables
    >({
      mutation: MUTATION,
      variables: {
        companyId,
        name,
      },
    });
    result.then(
      (response) => {
        if (response.data) {
          resolve(response.data.createOrganization);
        } else {
          // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- pre-existing contract: rejects the raw Apollo response
          reject(response);
        }
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getOrgForCompany(
  client: ApolloClient<object>,
  companyId: GetOrganizationForCompanyQueryVariables["companyId"]
): Promise<GetOrganizationForCompanyQuery["getOrganizationForCompany"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getOrganizationForCompany($companyId: ID!) {
        getOrganizationForCompany(companyId: $companyId) {
          name
          id
          companyLimit
          linkedCompanies {
            id
            name
            dba
            ein
            type
            size
            url
            planId
            currentState
          }
        }
      }
    `;
    const result = client.query<
      GetOrganizationForCompanyQuery,
      GetOrganizationForCompanyQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
      fetchPolicy: "network-only",
    });
    result.then(
      (response) => {
        resolve(response.data.getOrganizationForCompany);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getCompanyAdminsAndAgents(
  client: ApolloClient<object>,
  companyId: GetCompanyAdminsAndAgentsQueryVariables["companyId"]
): Promise<GetCompanyAdminsAndAgentsQuery["getCompanyAdminsAndAgents"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getCompanyAdminsAndAgents($companyId: ID!) {
        getCompanyAdminsAndAgents(companyId: $companyId) {
          user {
            id
            email
            username
            userRoleId
          }
          link {
            id
            invitationExpiresAt
            status
            companyId
            locked
          }
        }
      }
    `;
    const result = client.query<
      GetCompanyAdminsAndAgentsQuery,
      GetCompanyAdminsAndAgentsQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
      fetchPolicy: "network-only",
    });
    result.then(
      (response) => {
        resolve(response.data.getCompanyAdminsAndAgents);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function disableCompanyRequest(
  client: ApolloClient<object>,
  companyId: DisableCompanyMutationVariables["companyId"]
): Promise<DisableCompanyMutation["disableCompany"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation disableCompany($companyId: ID!) {
        disableCompany(companyId: $companyId) {
          state
        }
      }
    `;
    const result = client.mutate<
      DisableCompanyMutation,
      DisableCompanyMutationVariables
    >({
      mutation: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data?.disableCompany ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function enableCompanyRequest(
  client: ApolloClient<object>,
  companyId: EnableCompanyMutationVariables["companyId"]
): Promise<EnableCompanyMutation["enableCompany"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation enableCompany($companyId: ID!) {
        enableCompany(companyId: $companyId) {
          state
        }
      }
    `;
    const result = client.mutate<
      EnableCompanyMutation,
      EnableCompanyMutationVariables
    >({
      mutation: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data?.enableCompany ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getKybDocumentTypes(
  client: ApolloClient<object>,
  companyId: GetKybDocumentTypesQueryVariables["companyId"]
): Promise<GetKybDocumentTypesQuery["getKybDocumentTypes"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getKybDocumentTypes($companyId: ID!) {
        getKybDocumentTypes(companyId: $companyId) {
          id
          value
        }
      }
    `;
    const result = client.query<
      GetKybDocumentTypesQuery,
      GetKybDocumentTypesQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data.getKybDocumentTypes);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function submitKYBMemberDocuments(
  client: ApolloClient<object>,
  { companyId, documents }: SubmitKybMemberDocumentsMutationVariables
): Promise<
  SubmitKybMemberDocumentsMutation["submitKYBMemberDocuments"] | null
> {
  return new Promise((resolve, reject) => {
    const QUERY = gql`
      mutation submitKYBMemberDocuments(
        $companyId: ID!
        $documents: [BusinessDocumentInput!]
      ) {
        submitKYBMemberDocuments(companyId: $companyId, documents: $documents)
      }
    `;
    const result = client.mutate<
      SubmitKybMemberDocumentsMutation,
      SubmitKybMemberDocumentsMutationVariables
    >({
      mutation: QUERY,
      variables: {
        companyId,
        documents,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.submitKYBMemberDocuments ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function submitKYBBusinessDocuments(
  client: ApolloClient<object>,
  { companyId, documents }: SubmitKybBusinessDocumentsMutationVariables
): Promise<
  SubmitKybBusinessDocumentsMutation["submitKYBBusinessDocuments"] | null
> {
  return new Promise((resolve, reject) => {
    const QUERY = gql`
      mutation submitKYBBusinessDocuments(
        $companyId: ID!
        $documents: [DocumentInput!]
      ) {
        submitKYBBusinessDocuments(companyId: $companyId, documents: $documents)
      }
    `;
    const result = client.mutate<
      SubmitKybBusinessDocumentsMutation,
      SubmitKybBusinessDocumentsMutationVariables
    >({
      mutation: QUERY,
      variables: {
        companyId,
        documents,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.submitKYBBusinessDocuments ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getGroupsAndBanks(
  client: ApolloClient<object>,
  companyId: GetGroupsAndBanksQueryVariables["companyId"]
): Promise<GetGroupsAndBanksQuery> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getGroupsAndBanks($companyId: ID!) {
        getCompanyBanks(companyId: $companyId) {
          id
          bankName
          bankAlias
          verificationStatus
          accountType
          accountSubtype
          accountId
          correlationId
          state
        }
        getCompanyGroups(companyId: $companyId) {
          id
          name
          payrollFrequency
          useUniqueInviteCodes
          associatedBankAccount {
            id
            bankName
            accountId
          }
          associatedLinkRequests {
            status
            id
            employeeId
            userProfile {
              legalName
              firstName
              lastName
              email
              ssn
              lastFourOfSsn
            }
          }
          associatedInvitations {
            status
            id
          }

          schedule {
            anchorPayDate
            payrollProcessingOffset
            payrollFrequency
            dayOne
            dayTwo
            displayAnchorPayDate
            displayDayOne
            displayDayTwo
          }
          planType
          companyGroupIndex
        }
      }
    `;
    const result = client.query<
      GetGroupsAndBanksQuery,
      GetGroupsAndBanksQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getKybStatusForCompany(
  client: ApolloClient<object>,
  companyId: GetKybStatusForCompanyQueryVariables["companyId"]
): Promise<GetKybStatusForCompanyQuery> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getKybStatusForCompany($companyId: ID!) {
        getCompanyKybData(companyId: $companyId) {
          employerProfile {
            id
            email
            addressAlias
            address1
            address2
            city
            state
            postalCode
            businessName
            businessType
            doingBusinessAs
            naicsBusinessClassification
            ein
            website
            phone
          }
          silaWallet {
            id
            correlationId
            routingNumber
            accountNumber
            accountType
            name
            active
          }

          businessMembers {
            id
            businessMemberHandle
            role
            ownershipStake
            state
            memberProfile {
              legalName
              firstName
              lastName
              alias
              email
              phoneNumber
              ssn
              citizenshipCountry
              birthCountry
              permanentResident
              dob
              address1
              address2
              city
              state
              postalCode
              maritalStatus
              numberOfDependents
              employeeId
              phone
            }
          }
          documents {
            id
            uri
            contentType
            metadata {
              batchUploadCount
            }
            type
          }
          businessDocuments {
            id
            uri
            contentType
            name
            metadata {
              batchUploadCount
            }
            type
          }
          businessMemberDocuments {
            memberId
            id
            correlationId
            uri
            contentType
            name
            createdAt
            metadata {
              batchUploadCount
            }
            type
          }
        }
        getKybStatusForCompany(companyId: $companyId) {
          count
          kycResponses {
            reference
            message
            status
            success
            entityType
            verificationStatus
            validKycLevels
            verificationHistory {
              verificationId
              verificationStatus
              kycLevel
              requestedAt
              updatedAt
              score
              parentVerification {
                verificationStatus
                kycLevel
                requestedAt
                updatedAt
                score
              }
              tags
              reasons
            }
          }
        }
      }
    `;
    const result = client.query<
      GetKybStatusForCompanyQuery,
      GetKybStatusForCompanyQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function searchUsers(
  client: ApolloClient<object>,
  { search, limit, offset }: SearchUsersQueryVariables
): Promise<SearchUsersQuery["searchUsers"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query searchUsers($search: String!, $limit: Int!, $offset: Int!) {
        searchUsers(search: $search, limit: $limit, offset: $offset) {
          totalRows
          results {
            userInfo {
              id
              firstName
              lastName
              lastFourOfSsn
            }
            accounts {
              accountNumber
              type
            }
            contactInfo {
              legalName
              firstName
              lastName
              address1
              address2
              city
              state
              postalCode
              phoneNumber
              email
              dob
              lastFourOfSsn
            }
            kycCurrentState
          }
        }
      }
    `;
    const result = client.query<SearchUsersQuery, SearchUsersQueryVariables>({
      query: REQUEST,
      variables: { search, limit, offset },
    });
    result.then(
      (response) => {
        resolve(response.data.searchUsers);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getUserDetails(
  client: ApolloClient<object>,
  userId: GetUserDetailsQueryVariables["userId"]
): Promise<GetUserDetailsQuery["getUserDetails"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getUserDetails($userId: ID!) {
        getUserDetails(userId: $userId) {
          fullSsn
          user {
            firstName
            lastName
            email
            id
            state
            createdAt
            userAuthorizations {
              id
              identityProvider
              identityProviderId
              deleted
            }
          }
          userProfile {
            legalName
            firstName
            lastName
            address1
            address2
            city
            state
            postalCode
            phoneNumber
            email
            dob
            ssn
          }
          accounts {
            id
            routingNumber
            accountNumber
            name
            accountType
            createdAt
            active
            balances {
              withdrawalBalance
              totalAccountBalance
              cashBalance
              principal
              totalPendingContributions
              totalPendingDistributions
              totalAccountInvestmentBalance
            }
          }
        }
      }
    `;
    const result = client.query<
      GetUserDetailsQuery,
      GetUserDetailsQueryVariables
    >({
      query: REQUEST,
      variables: { userId },
    });
    result.then(
      (response) => {
        resolve(response.data.getUserDetails);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getPricingSheet(
  client: ApolloClient<object>
): Promise<GetPricingSheetQuery["getPricingSheet"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPricingSheet {
        getPricingSheet {
          subscriptions {
            id
            metadata
            unitAmount
            recurring
          }
          setupFees {
            id
            metadata
            unitAmount
          }
          perUserFees {
            id
            metadata
            unitAmount
          }
        }
      }
    `;
    const result = client.query<
      GetPricingSheetQuery,
      GetPricingSheetQueryVariables
    >({
      query: REQUEST,
      variables: {},
    });
    result.then(
      (response) => {
        resolve(response.data.getPricingSheet);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getBillingDetailsForCompany(
  client: ApolloClient<object>,
  companyId: GetBillingDetailsForCompanyQueryVariables["companyId"]
): Promise<GetBillingDetailsForCompanyQuery["getBillingDetailsForCompany"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getBillingDetailsForCompany($companyId: ID!) {
        getBillingDetailsForCompany(companyId: $companyId) {
          monthlyFee
          perUserFee
          nextBillingDate
          subscriptionId
          billingContactEmail
          stripeCustomerId
          metadata
          billingFrequency
          subscriptions {
            subscriptionId
            status
            active
            collectionMethod
            currentPeriodStart
            currentPeriodEnd
            canceledAt
            endedAt
            prices {
              priceId
              lookupKey
              amount
              interval
              quantity
            }
          }
          scheduledSubscriptions {
            scheduleId
            status
            startDate
            collectionMethod
            coupon
            prices {
              priceId
              lookupKey
              amount
              interval
              quantity
            }
            setupFees {
              priceId
              lookupKey
              amount
              interval
              quantity
            }
          }
        }
      }
    `;
    const result = client.query<
      GetBillingDetailsForCompanyQuery,
      GetBillingDetailsForCompanyQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
      // a failed subscription lookup must not read as "no billing" and offer Setup Billing again
      errorPolicy: "none",
    });
    result.then(
      (response) => {
        resolve(response.data.getBillingDetailsForCompany);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function createInvoiceForCompany(
  client: ApolloClient<object>,
  {
    subscriptionId,
    setupFeeId,
    companyId,
    billingContactEmail,
    anchorBillingDate,
    perUserFeeId,
    billedInArrears,
    discountPercent,
    discountLength,
  }: CreateInvoiceForCompanyMutationVariables
): Promise<CreateInvoiceForCompanyMutation["createInvoiceForCompany"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation createInvoiceForCompany(
        $companyId: ID!
        $subscriptionId: ID
        $setupFeeId: ID
        $perUserFeeId: ID
        $billingContactEmail: String!
        $anchorBillingDate: String!
        $billedInArrears: Boolean!
        $discountPercent: Int
        $discountLength: DiscountLengths
      ) {
        createInvoiceForCompany(
          companyId: $companyId
          subscriptionId: $subscriptionId
          setupFeeId: $setupFeeId
          perUserFeeId: $perUserFeeId
          billingContactEmail: $billingContactEmail
          anchorBillingDate: $anchorBillingDate
          billedInArrears: $billedInArrears
          discountPercent: $discountPercent
          discountLength: $discountLength
        ) {
          monthlyFee
          perUserFee
          nextBillingDate
          subscriptionId
          billingContactEmail
          stripeCustomerId
          metadata
          billingFrequency
        }
      }
    `;
    const result = client.mutate<
      CreateInvoiceForCompanyMutation,
      CreateInvoiceForCompanyMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        subscriptionId,
        setupFeeId,
        companyId,
        billingContactEmail,
        anchorBillingDate,
        perUserFeeId,
        billedInArrears,
        discountPercent,
        discountLength,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.createInvoiceForCompany ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getPendingAndLinkedEmployers(
  client: ApolloClient<object>,
  userId: GetPendingAndLinkedEmployersQueryVariables["userId"]
): Promise<GetPendingAndLinkedEmployersQuery["getPendingAndLinkedEmployers"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPendingAndLinkedEmployers($userId: ID!) {
        getPendingAndLinkedEmployers(userId: $userId) {
          pendingEmployers {
            id
            status
            company {
              id
              name
              planId
              enabledProductFeatures
            }
            group {
              id
              payrollFrequency
              companyGroupIndex
              useUniqueInviteCodes
              name
            }
            contribution {
              amount
              id
              contributionChangeRequests {
                userCurrentContributionAmount
                userNewContributionAmount
                status
                id
              }
            }
          }

          linkedEmployers {
            id
            deleted
            company {
              id
              name
              planId
            }
            group {
              id
              name
              payrollFrequency
              companyGroupIndex
            }
            contribution {
              amount
              id
              contributionChangeRequests {
                status
                id
                userCurrentContributionAmount
                userNewContributionAmount
              }
            }
          }
        }
      }
    `;
    const result = client.query<
      GetPendingAndLinkedEmployersQuery,
      GetPendingAndLinkedEmployersQueryVariables
    >({
      query: REQUEST,
      variables: { userId },
    });
    result.then(
      (response) => {
        resolve(response.data.getPendingAndLinkedEmployers);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function liquidateUserAccount(
  client: ApolloClient<object>,
  {
    userId,
    accountId,
    closeAccount,
    reason,
    closeAccountType,
  }: LiquidateUserAccountMutationVariables
): Promise<LiquidateUserAccountMutation["liquidateUserAccount"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation liquidateUserAccount(
        $userId: ID!
        $accountId: ID!
        $closeAccount: Boolean
        $reason: String
        $closeAccountType: String
      ) {
        liquidateUserAccount(
          userId: $userId
          accountId: $accountId
          closeAccount: $closeAccount
          reason: $reason
          closeAccountType: $closeAccountType
        )
      }
    `;
    const result = client.mutate<
      LiquidateUserAccountMutation,
      LiquidateUserAccountMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        userId,
        accountId,
        closeAccount,
        reason,
        closeAccountType,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.liquidateUserAccount ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function resetUserState(
  client: ApolloClient<object>,
  userId: ResetUserStateMutationVariables["userId"]
): Promise<ResetUserStateMutation["resetUserState"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation resetUserState($userId: ID!) {
        resetUserState(userId: $userId)
      }
    `;
    const result = client.mutate<
      ResetUserStateMutation,
      ResetUserStateMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        userId,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.resetUserState ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function partiallyDisburseUserAccount(
  client: ApolloClient<object>,
  {
    userId,
    accountId,
    reason,
    amount,
  }: PartiallyDisburseUserAccountMutationVariables
): Promise<
  PartiallyDisburseUserAccountMutation["partiallyDisburseUserAccount"]
> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation partiallyDisburseUserAccount(
        $userId: ID!
        $accountId: ID!
        $reason: String!
        $amount: Float!
      ) {
        partiallyDisburseUserAccount(
          userId: $userId
          accountId: $accountId
          reason: $reason
          amount: $amount
        )
      }
    `;
    const result = client.mutate<
      PartiallyDisburseUserAccountMutation,
      PartiallyDisburseUserAccountMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        userId,
        accountId,
        reason,
        amount,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.partiallyDisburseUserAccount ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getPayrolls(
  client: ApolloClient<object>,
  { companyId, order, status, offset, limit }: GetPayrollsQueryVariables
): Promise<GetPayrollsQuery["getPayrolls"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPayrolls(
        $companyId: ID
        $status: PayrollStatus
        $order: Order
        $offset: Int!
        $limit: Int!
      ) {
        getPayrolls(
          status: $status
          order: $order
          companyId: $companyId
          limit: $limit
          offset: $offset
        ) {
          totalRows
          currentOffset
          limit
          nextOffset
          pageSize
          results {
            id
            employerId
            totalAmount
            bankId
            status
            state
            createdAt
            payrollDocumentId
            period {
              start
              end
              displayStart
              displayEnd
            }
            metadata
            employerGroup {
              id
              name
            }
          }
        }
      }
    `;
    const result = client.query<GetPayrollsQuery, GetPayrollsQueryVariables>({
      query: REQUEST,
      variables: { companyId, order, status, offset, limit },
    });
    result.then(
      (response) => {
        resolve(response.data.getPayrolls);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function reopenUserAccount(
  client: ApolloClient<object>,
  {
    userId,
    accountId,
    reason,
    isAdministrativeReopen,
  }: ReopenUserAccountMutationVariables
): Promise<ReopenUserAccountMutation["reopenUserAccount"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation reopenUserAccount(
        $userId: ID!
        $accountId: ID!
        $reason: String!
        $isAdministrativeReopen: Boolean!
      ) {
        reopenUserAccount(
          userId: $userId
          accountId: $accountId
          reason: $reason
          isAdministrativeReopen: $isAdministrativeReopen
        )
      }
    `;
    const result = client.mutate<
      ReopenUserAccountMutation,
      ReopenUserAccountMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        userId,
        accountId,
        reason,
        isAdministrativeReopen,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.reopenUserAccount ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getContributionAbilityRequest(
  client: ApolloClient<object>,
  userId: AdminGetContributionAbilityQueryVariables["userId"]
): Promise<AdminGetContributionAbilityQuery["getContributionAbility"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query adminGetContributionAbility($userId: ID!) {
        getContributionAbility(userId: $userId) {
          userId
          currentYear {
            taxYear
            totalContributionAmount
            amountRemaining
            limit
            canContribute
          }
          priorYear {
            taxYear
            totalContributionAmount
            amountRemaining
            limit
            canContribute
          }
          history {
            taxYear
            totalContributionAmount
            amountRemaining
            limit
            canContribute
          }
          isWithinPriorYearContributionWindow
          allYears {
            taxYear
            totalContributionAmount
            amountRemaining
            limit
            canContribute
          }
        }
      }
    `;
    const result = client.query<
      AdminGetContributionAbilityQuery,
      AdminGetContributionAbilityQueryVariables
    >({
      query: REQUEST,
      variables: { userId },
    });
    result.then(
      (response) => {
        resolve(response.data.getContributionAbility);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getEntityLimitsRequest(
  client: ApolloClient<object>,
  entityType: GetEntityLimitsQueryVariables["entityType"],
  entityId: GetEntityLimitsQueryVariables["entityId"]
): Promise<GetEntityLimitsQuery["getEntityLimits"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getEntityLimits($entityType: EntityType!, $entityId: ID) {
        getEntityLimits(entityType: $entityType, entityId: $entityId) {
          key
          value
        }
      }
    `;
    const result = client.query<
      GetEntityLimitsQuery,
      GetEntityLimitsQueryVariables
    >({
      query: REQUEST,
      variables: { entityType, entityId },
    });
    result.then(
      (response) => {
        resolve(response.data.getEntityLimits);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function updateEntityLimitRequest(
  client: ApolloClient<object>,
  { entityType, entityId, key, value }: UpdateEntityLimitMutationVariables
): Promise<UpdateEntityLimitMutation["updateEntityLimit"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation updateEntityLimit(
        $entityType: EntityType!
        $entityId: ID
        $key: String!
        $value: String!
      ) {
        updateEntityLimit(
          entityType: $entityType
          entityId: $entityId
          key: $key
          value: $value
        ) {
          key
          value
        }
      }
    `;
    const result = client.mutate<
      UpdateEntityLimitMutation,
      UpdateEntityLimitMutationVariables
    >({
      mutation: request,
      variables: {
        entityType,
        entityId,
        key,
        value,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.updateEntityLimit ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function linkEmployerToCrmRequest(
  client: ApolloClient<object>,
  { companyId, providerReferenceId }: LinkEmployerToCrmMutationVariables
): Promise<LinkEmployerToCrmMutation["linkEmployerToCrm"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation linkEmployerToCrm($companyId: ID!, $providerReferenceId: ID!) {
        linkEmployerToCrm(
          companyId: $companyId
          providerReferenceId: $providerReferenceId
        )
      }
    `;
    const result = client.mutate<
      LinkEmployerToCrmMutation,
      LinkEmployerToCrmMutationVariables
    >({
      mutation: request,
      variables: {
        companyId,
        providerReferenceId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.linkEmployerToCrm ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function unlinkEmployerToCrmRequest(
  client: ApolloClient<object>,
  { companyId, linkId }: UnlinkEmployerToCrmMutationVariables
): Promise<UnlinkEmployerToCrmMutation["unlinkEmployerToCrm"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation unlinkEmployerToCrm($companyId: ID!, $linkId: ID!) {
        unlinkEmployerToCrm(companyId: $companyId, linkId: $linkId)
      }
    `;
    const result = client.mutate<
      UnlinkEmployerToCrmMutation,
      UnlinkEmployerToCrmMutationVariables
    >({
      mutation: request,
      variables: {
        companyId,
        linkId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.unlinkEmployerToCrm ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getEmployerCrmLinkRequest(
  client: ApolloClient<object>,
  { companyId }: GetEmployerCrmLinkQueryVariables
): Promise<GetEmployerCrmLinkQuery["companyById"]["crmLink"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getEmployerCrmLink($companyId: ID!) {
        companyById(companyId: $companyId) {
          crmLink {
            id
            providerReferenceId
          }
        }
      }
    `;
    const result = client.query<
      GetEmployerCrmLinkQuery,
      GetEmployerCrmLinkQueryVariables
    >({
      query: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data.companyById.crmLink);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function syncCrmRequest(
  client: ApolloClient<object>,
  { companyId }: SyncCrmMutationVariables
): Promise<SyncCrmMutation["syncCrm"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation syncCrm($companyId: ID!) {
        syncCrm(companyId: $companyId)
      }
    `;
    const result = client.mutate<SyncCrmMutation, SyncCrmMutationVariables>({
      mutation: request,
      variables: {
        companyId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.syncCrm ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function updateBillingType(
  client: ApolloClient<object>,
  { companyId, billingType }: UpdateBillingTypeMutationVariables
): Promise<UpdateBillingTypeMutation["updateBillingType"] | null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation updateBillingType($companyId: ID!, $billingType: String!) {
        updateBillingType(companyId: $companyId, billingType: $billingType)
      }
    `;
    const result = client.mutate<
      UpdateBillingTypeMutation,
      UpdateBillingTypeMutationVariables
    >({
      mutation: request,
      variables: {
        companyId,
        billingType,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.updateBillingType ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getAllUnprocessedPayrollsRequest(
  client: ApolloClient<object>,
  { companyId, limit, offset, date }: UnprocessedPayrollsQueryVariables
): Promise<UnprocessedPayrollsQuery["unprocessedPayrolls"]> {
  return new Promise((resolve, reject) => {
    const request = gql`
      query unprocessedPayrolls(
        $companyId: ID
        $limit: Int!
        $offset: Int!
        $date: Date!
      ) {
        unprocessedPayrolls(
          companyId: $companyId
          limit: $limit
          offset: $offset
          date: $date
        ) {
          total
          offset
          limit
          nextOffset
          count
          results {
            payrollId
            start
            end
            payrollProcessingDate
            onOrAfterPayrollProcessingDate
            lastPayrollApprovalDate
            status
            gracePeriodEndDate
            payPeriodStart
            payPeriodEnd
            periodState
            payPeriodId
            groupId
            userCount
            payrollType
            amount
            entity {
              id
            }
          }
        }
      }
    `;
    const result = client.query<
      UnprocessedPayrollsQuery,
      UnprocessedPayrollsQueryVariables
    >({
      query: request,
      variables: {
        companyId,
        limit,
        offset,
        date,
      },
    });
    result.then(
      (data) => {
        resolve(data.data.unprocessedPayrolls);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getWorkflows(
  client: ApolloClient<object>,
  {
    entityId,
    status,
    offset,
    limit,
    updatedAtStart,
    updatedAtEnd,
    name,
    id,
  }: GetPaginatedWorkflowsQueryVariables
): Promise<GetPaginatedWorkflowsQuery["getPaginatedWorkflows"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPaginatedWorkflows(
        $entityId: ID
        $status: WorkflowStatus
        $offset: Int!
        $limit: Int!
        $name: String
        $id: ID
        $updatedAtStart: String
        $updatedAtEnd: String
      ) {
        getPaginatedWorkflows(
          status: $status
          entityId: $entityId
          limit: $limit
          offset: $offset
          updatedAtStart: $updatedAtStart
          name: $name
          id: $id
          updatedAtEnd: $updatedAtEnd
        ) {
          totalRows
          currentOffset
          limit
          nextOffset
          pageSize
          filterValues
          results {
            createdAt
            description
            entityId
            entityType
            id
            leaseExpiresAt
            name
            pausedUntil
            status
            updatedAt
            workflow {
              description
              id
              name
              params
              root {
                class
                className
                description
                id
                sibling {
                  class
                  className
                  description
                  id
                }
              }
            }
          }
        }
      }
    `;
    const result = client.query<
      GetPaginatedWorkflowsQuery,
      GetPaginatedWorkflowsQueryVariables
    >({
      query: REQUEST,
      variables: {
        entityId,
        status,
        offset,
        limit,
        updatedAtStart,
        updatedAtEnd,
        name,
        id,
      },
    });
    result.then(
      (response) => {
        resolve(response.data.getPaginatedWorkflows);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function restartWorkflowRequest(
  client: ApolloClient<object>,
  workflowId: RestartWorkflowMutationVariables["workflowId"]
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation restartWorkflow($workflowId: ID!) {
        restartWorkflow(workflowId: $workflowId)
      }
    `;
    const result = client.mutate<
      RestartWorkflowMutation,
      RestartWorkflowMutationVariables
    >({
      mutation: REQUEST,
      variables: { workflowId },
    });
    result.then(
      (response) => {
        if (response.data?.restartWorkflow === true) {
          resolve(true);
        } else {
          reject(new Error("Workflow could not be restarted."));
        }
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getLastWorkflowStep(
  client: ApolloClient<object>,
  workflowId: GetLastWorkflowStepQueryVariables["workflowId"]
): Promise<GetLastWorkflowStepQuery["getLastWorkflowStep"]> {
  return new Promise((resolve, reject) => {
    const request = gql`
      query getLastWorkflowStep($workflowId: ID!) {
        getLastWorkflowStep(workflowId: $workflowId) {
          id
          stepId
          className
          updatedAt
          result {
            status
            output
          }
        }
      }
    `;
    const result = client.query<
      GetLastWorkflowStepQuery,
      GetLastWorkflowStepQueryVariables
    >({
      query: request,
      variables: {
        workflowId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data.getLastWorkflowStep);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getReportTypes(
  client: ApolloClient<object>
): Promise<GetReportTypesQuery["getReportTypes"]> {
  return new Promise((resolve, reject) => {
    const request = gql`
      query getReportTypes {
        getReportTypes {
          description
          reportType
          parameters {
            name
            description
            type
            isArray
            required
          }
        }
      }
    `;
    const result = client.query<
      GetReportTypesQuery,
      GetReportTypesQueryVariables
    >({
      query: request,
    });
    result.then(
      (data) => {
        resolve(data.data.getReportTypes);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getCustomReports(
  client: ApolloClient<object>,
  { limit, offset }: GetCustomReportsQueryVariables
): Promise<GetCustomReportsQuery["getCustomReports"]> {
  return new Promise((resolve, reject) => {
    const request = gql`
      query getCustomReports($limit: Int!, $offset: Int!) {
        getCustomReports(limit: $limit, offset: $offset) {
          reports {
            id
            locationUri
            status
            reportRequest {
              reportName
              requestedBy
              reportDefinition {
                reportType
                description
              }
            }
          }
          count
        }
      }
    `;
    const result = client.query<
      GetCustomReportsQuery,
      GetCustomReportsQueryVariables
    >({
      query: request,
      variables: {
        limit,
        offset,
      },
    });
    result.then(
      (data) => {
        resolve(data.data.getCustomReports);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getReportCSV(
  client: ApolloClient<object>,
  reportId: GetReportCsvQueryVariables["reportId"]
): Promise<GetReportCsvQuery["getReportCSV"]> {
  return new Promise((resolve, reject) => {
    const request = gql`
      query getReportCSV($reportId: ID!) {
        getReportCSV(reportId: $reportId)
      }
    `;
    const result = client.query<GetReportCsvQuery, GetReportCsvQueryVariables>({
      query: request,
      variables: {
        reportId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data.getReportCSV);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function createCustomReport(
  client: ApolloClient<object>,
  {
    startDate,
    endDate,
    reportName,
    reportType,
    requestedBy,
    employerId,
    userId,
    accountId,
    accountNumber,
    entityId,
    entityType,
    employerIds,
    entityIds,
    userIds,
    accountIds,
    ids,
  }: Omit<CreateCustomReportMutationVariables, "params"> & CustomReportInput
): Promise<null> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation createCustomReport(
        $requestedBy: ID!
        $reportName: String!
        $reportType: String!
        $params: CustomReportInput!
      ) {
        createCustomReport(
          requestedBy: $requestedBy
          reportName: $reportName
          params: $params
          reportType: $reportType
        )
      }
    `;
    const result = client.mutate<
      CreateCustomReportMutation,
      CreateCustomReportMutationVariables
    >({
      mutation: request,
      variables: {
        requestedBy,
        reportName,
        reportType,
        params: {
          startDate,
          endDate,
          employerId,
          userId,
          accountId,
          accountNumber,
          entityId,
          entityType,
          employerIds,
          entityIds,
          userIds,
          ids,
          accountIds,
        },
      },
    });
    result.then(
      (data) => {
        // batch-4 finding (preserved as-is): the `createCustomReport` mutation
        // returns a `createCustomReport` field, but this reads `getWorkflowSteps`
        // (copy-paste from `getWorkflows`) — the field has never existed on the
        // response, so this has always resolved `undefined`/null. Cast keeps the
        // pre-existing behavior; see docs/TYPESCRIPT-MIGRATION.md batch-4 findings.
        resolve(
          (data.data as unknown as { getWorkflowSteps?: null } | null)
            ?.getWorkflowSteps ?? null
        );
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function updateBillingContact(
  client: ApolloClient<object>,
  { email, companyId }: UpdateCompanyBillingContactMutationVariables
): Promise<
  UpdateCompanyBillingContactMutation["updateCompanyBillingContact"] | null
> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation updateCompanyBillingContact($companyId: ID!, $email: String!) {
        updateCompanyBillingContact(companyId: $companyId, email: $email) {
          monthlyFee
          perUserFee
          nextBillingDate
          subscriptionId
          billingContactEmail
          stripeCustomerId
          metadata
        }
      }
    `;
    const result = client.mutate<
      UpdateCompanyBillingContactMutation,
      UpdateCompanyBillingContactMutationVariables
    >({
      mutation: request,
      variables: {
        email,
        companyId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.updateCompanyBillingContact ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function approvePayrollIntegrationSetup(
  client: ApolloClient<object>,
  { companyId }: ApprovePayrollIntegrationSetupMutationVariables
): Promise<
  ApprovePayrollIntegrationSetupMutation["approvePayrollIntegrationSetup"]
> {
  return new Promise((resolve, reject) => {
    const request = gql`
      mutation approvePayrollIntegrationSetup($companyId: ID!) {
        approvePayrollIntegrationSetup(companyId: $companyId)
      }
    `;
    const result = client.mutate<
      ApprovePayrollIntegrationSetupMutation,
      ApprovePayrollIntegrationSetupMutationVariables
    >({
      mutation: request,
      variables: {
        companyId,
      },
    });
    result.then(
      (data) => {
        resolve(data.data?.approvePayrollIntegrationSetup ?? null);
      },
      (errors: Error) => {
        reject(errors);
      }
    );
  });
}

export function getKybStatus(
  client: ApolloClient<object>,
  companyId: GetKybStatusQueryVariables["companyId"]
): Promise<GetKybStatusQuery["getKybStatus"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getKybStatus($companyId: ID!) {
        getKybStatus(companyId: $companyId) {
          verificationStatus
          count
          kycResponses {
            rawResponse {
              reference
              message
              status
              success
              entityType
              verificationStatus
              verificationHistory {
                verificationId
                verificationStatus
                kycLevel
                requestedAt
                updatedAt
                score
                parentVerification {
                  verificationStatus
                  kycLevel
                  requestedAt
                  updatedAt
                  score
                }
                tags
                reasons
              }
            }
          }
        }
      }
    `;
    const result = client.query<GetKybStatusQuery, GetKybStatusQueryVariables>({
      query: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data.getKybStatus);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getReportsStatuses(
  client: ApolloClient<object>,
  reportIds: GetReportsStatusQueryVariables["reportIds"]
): Promise<GetReportsStatusQuery["getReportsStatus"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getReportsStatus($reportIds: [ID!]) {
        getReportsStatus(reportIds: $reportIds) {
          id
          locationUri
          status
          reportRequest {
            reportName
            requestedBy
            reportDefinition {
              reportType
              description
            }
          }
        }
      }
    `;
    const result = client.query<
      GetReportsStatusQuery,
      GetReportsStatusQueryVariables
    >({
      query: REQUEST,
      variables: { reportIds },
    });
    result.then(
      (response) => {
        resolve(response.data.getReportsStatus);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function migrateEmployeesForCompany(
  client: ApolloClient<object>,
  {
    companyId,
    sourceGroupId,
    targetGroupId,
    employeesForMigration,
  }: MigrateEmployeesForCompanyMutationVariables
): Promise<
  MigrateEmployeesForCompanyMutation["migrateEmployeesForCompany"] | null
> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation migrateEmployeesForCompany(
        $employeesForMigration: [ID!]!
        $companyId: ID!
        $sourceGroupId: ID!
        $targetGroupId: ID!
      ) {
        migrateEmployeesForCompany(
          companyId: $companyId
          sourceGroupId: $sourceGroupId
          targetGroupId: $targetGroupId
          employeesForMigration: $employeesForMigration
        ) {
          id
          name
          payrollFrequency
          useUniqueInviteCodes
          associatedBankAccount {
            id
            bankName
            accountId
          }
          associatedLinkRequests {
            status
            id
            employeeId
            userProfile {
              legalName
              firstName
              lastName
              email
              ssn
              lastFourOfSsn
            }
          }
          schedule {
            anchorPayDate
            displayAnchorPayDate
            displayDayOne
            displayDayTwo
          }
          planType
          companyGroupIndex
        }
      }
    `;
    const result = client.mutate<
      MigrateEmployeesForCompanyMutation,
      MigrateEmployeesForCompanyMutationVariables
    >({
      mutation: REQUEST,
      variables: {
        companyId,
        sourceGroupId,
        targetGroupId,
        employeesForMigration,
      },
    });
    result.then(
      (response) => {
        resolve(response.data?.migrateEmployeesForCompany ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getEmployerOrders(
  client: ApolloClient<object>,
  { limit, offset, search }: GetEmployerOrdersQueryVariables
): Promise<GetEmployerOrdersQuery["getEmployerOrders"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getEmployerOrders($limit: Int!, $offset: Int!, $search: String) {
        getEmployerOrders(limit: $limit, offset: $offset, search: $search) {
          rows {
            id
            signupCode
            status
            failureReason
            docusignEnvelopeId
            stripeCustomerId
            companyId
            companyName
            businessName
            ein
            billingContactEmail
            phone
            priceLookupKey
            setupFee
            billingTerm
            discount
            billingDeferral
            completedDateTime
            createdAt
          }
          count
        }
      }
    `;
    const result = client.query<
      GetEmployerOrdersQuery,
      GetEmployerOrdersQueryVariables
    >({
      query: REQUEST,
      variables: { limit, offset, search },
      fetchPolicy: "network-only",
      // reject on errors rather than resolving null data under the app client's errorPolicy "all"
      errorPolicy: "none",
    });
    result.then(
      (response) => {
        resolve(response.data.getEmployerOrders);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getUserRollovers(
  client: ApolloClient<object>,
  userId: UserRolloversQueryVariables["userId"]
): Promise<UserRolloversQuery["userRollovers"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query userRollovers($userId: ID!) {
        userRollovers(userId: $userId) {
          amount
          status
          accountId
          docId
          accountNumber
          createdAt
          updatedAt
          originationSource
          financialInstitution
          fundsTransferMethod
        }
      }
    `;
    const result = client.query<
      UserRolloversQuery,
      UserRolloversQueryVariables
    >({
      query: REQUEST,
      variables: { userId },
    });
    result.then(
      (response) => {
        resolve(response.data.userRollovers);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getSecurityDetailsRequest(
  client: ApolloClient<object>
): Promise<GetSecurityDetailsQuery["getSecurityDetails"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getSecurityDetails {
        getSecurityDetails {
          counts {
            totalPayrolls
            processingPayrolls
            consecutiveAchReturns
            achReturns
            unauthorizedAchReturns
            achReturnPercentage
            unauthorizedAchReturnPercentage
            lookBackDays
          }
        }
      }
    `;
    const result = client.query<
      GetSecurityDetailsQuery,
      GetSecurityDetailsQueryVariables
    >({
      query: REQUEST,
    });
    result.then(
      (response) => {
        resolve(response.data.getSecurityDetails);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function paychexUsersReport(
  client: ApolloClient<object>,
  userIds: GetPaychexUsersReportQueryVariables["userIds"]
): Promise<GetPaychexUsersReportQuery["getPaychexUsersReport"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPaychexUsersReport($userIds: [ID!]!) {
        getPaychexUsersReport(userIds: $userIds) {
          userId
          email
          paychexMetadata
          createdAt
          iconAccounts {
            accountType
            accountNumber
            balances {
              withdrawalBalance
              totalAccountBalance
              cashBalance
              principal
              totalPendingContributions
              totalPendingDistributions
            }
            rollovers {
              amount
              status
              createdAt
              updatedAt
            }
          }
          paychexAccounts {
            accountType
            balance
          }
          userState
          stateLastUpdated
          userStateTriggerEvent
          userCurrentStateMachine
          userAuthorizations {
            id
            identityProvider
            identityProviderId
          }
        }
      }
    `;
    const result = client.query<
      GetPaychexUsersReportQuery,
      GetPaychexUsersReportQueryVariables
    >({
      query: REQUEST,
      variables: { userIds },
    });
    result.then(
      (response) => {
        resolve(response.data.getPaychexUsersReport);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function freezeEmployer(
  client: ApolloClient<object>,
  companyId: FreezeEmployerMutationVariables["companyId"]
): Promise<FreezeEmployerMutation["freezeEmployer"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation freezeEmployer($companyId: ID!) {
        freezeEmployer(companyId: $companyId) {
          status
        }
      }
    `;
    const result = client.mutate<
      FreezeEmployerMutation,
      FreezeEmployerMutationVariables
    >({
      mutation: REQUEST,
      variables: { companyId },
    });
    result.then(
      (response) => {
        resolve(response.data?.freezeEmployer ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function unfreezeEmployer(
  client: ApolloClient<object>,
  companyId: UnfreezeEmployerMutationVariables["companyId"],
  uploadedFiles: UnfreezeEmployerMutationVariables["uploadedFiles"]
): Promise<UnfreezeEmployerMutation["unfreezeEmployer"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation unfreezeEmployer(
        $companyId: ID!
        $uploadedFiles: [DocumentInput!]
      ) {
        unfreezeEmployer(companyId: $companyId, uploadedFiles: $uploadedFiles) {
          status
        }
      }
    `;
    const result = client.mutate<
      UnfreezeEmployerMutation,
      UnfreezeEmployerMutationVariables
    >({
      mutation: REQUEST,
      variables: { companyId, uploadedFiles },
    });
    result.then(
      (response) => {
        resolve(response.data?.unfreezeEmployer ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getPaychexUsers(
  client: ApolloClient<object>
): Promise<GetPaychexUsersQuery["getPaychexUsers"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getPaychexUsers {
        getPaychexUsers {
          userId
        }
      }
    `;
    const result = client.query<
      GetPaychexUsersQuery,
      GetPaychexUsersQueryVariables
    >({
      query: REQUEST,
    });
    result.then(
      (response) => {
        resolve(response.data.getPaychexUsers);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function requestMemberFieldEdit(
  client: ApolloClient<object>,
  params: MemberFieldEditInput
): Promise<RequestMemberFieldEditMutation["requestMemberFieldEdit"] | null> {
  const { companyId, memberId, fieldType, value, address } = params;
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation requestMemberFieldEdit($input: MemberFieldEditInput!) {
        requestMemberFieldEdit(input: $input)
      }
    `;

    const input: MemberFieldEditInput = { companyId, memberId, fieldType };
    if (value) input.value = value;
    if (address) input.address = address;

    const result = client.mutate<
      RequestMemberFieldEditMutation,
      RequestMemberFieldEditMutationVariables
    >({
      mutation: REQUEST,
      variables: { input },
    });
    result.then(
      (response) => {
        resolve(response.data?.requestMemberFieldEdit ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function advanceYellowPathJourneyRequest(
  client: ApolloClient<object>,
  { entityType, entityId, companyId }: AdvanceYellowPathJourneyMutationVariables
): Promise<
  AdvanceYellowPathJourneyMutation["advanceYellowPathJourney"] | null
> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation advanceYellowPathJourney(
        $entityType: EntityType!
        $entityId: String!
        $companyId: String
      ) {
        advanceYellowPathJourney(
          entityType: $entityType
          entityId: $entityId
          companyId: $companyId
        )
      }
    `;
    const result = client.mutate<
      AdvanceYellowPathJourneyMutation,
      AdvanceYellowPathJourneyMutationVariables
    >({
      mutation: REQUEST,
      variables: { entityType, entityId, companyId },
    });
    result.then(
      (response) => {
        resolve(response.data?.advanceYellowPathJourney ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function requestBusinessRegistrationUpdate(
  client: ApolloClient<object>,
  params: BusinessRegistrationUpdateInput
): Promise<
  | RequestBusinessRegistrationUpdateMutation["requestBusinessRegistrationUpdate"]
  | null
> {
  const { companyId, address, ein, businessName } = params;
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation requestBusinessRegistrationUpdate(
        $input: BusinessRegistrationUpdateInput!
      ) {
        requestBusinessRegistrationUpdate(input: $input)
      }
    `;

    const input: BusinessRegistrationUpdateInput = { companyId };
    if (address) input.address = address;
    if (ein) input.ein = ein;
    if (businessName) input.businessName = businessName;

    const result = client.mutate<
      RequestBusinessRegistrationUpdateMutation,
      RequestBusinessRegistrationUpdateMutationVariables
    >({
      mutation: REQUEST,
      variables: { input },
    });
    result.then(
      (response) => {
        resolve(response.data?.requestBusinessRegistrationUpdate ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function getAlloyApplication(
  client: ApolloClient<object>,
  userId: GetAlloyApplicationQueryVariables["userId"]
): Promise<GetAlloyApplicationQuery["getAlloyApplication"]> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      query getAlloyApplication($userId: ID!) {
        getAlloyApplication(userId: $userId)
      }
    `;
    const result = client.query<
      GetAlloyApplicationQuery,
      GetAlloyApplicationQueryVariables
    >({
      query: REQUEST,
      variables: { userId },
      fetchPolicy: "network-only",
    });
    result.then(
      (response) => {
        resolve(response.data.getAlloyApplication);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function updateUserEmail(
  client: ApolloClient<object>,
  { userId, newEmail }: UpdateUserEmailInput
): Promise<UpdateUserEmailMutation["updateUserEmail"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation updateUserEmail($input: UpdateUserEmailInput!) {
        updateUserEmail(input: $input)
      }
    `;
    const result = client.mutate<
      UpdateUserEmailMutation,
      UpdateUserEmailMutationVariables
    >({
      mutation: REQUEST,
      variables: { input: { userId, newEmail } },
    });
    result.then(
      (response) => {
        resolve(response.data?.updateUserEmail ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function updateUserKyc(
  client: ApolloClient<object>,
  params: UpdateUserKycInput
): Promise<UpdateUserKycMutation["updateUserKyc"] | null> {
  const { userId, fieldType, value, address } = params;
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation updateUserKyc($input: UpdateUserKycInput!) {
        updateUserKyc(input: $input)
      }
    `;

    const input: UpdateUserKycInput = { userId, fieldType };
    if (value) input.value = value;
    if (address) input.address = address;

    const result = client.mutate<
      UpdateUserKycMutation,
      UpdateUserKycMutationVariables
    >({
      mutation: REQUEST,
      variables: { input },
    });
    result.then(
      (response) => {
        resolve(response.data?.updateUserKyc ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export function adminUpdateUserProfile(
  client: ApolloClient<object>,
  { userId, profileParams }: AdminUpdateUserProfileMutationVariables
): Promise<AdminUpdateUserProfileMutation["adminUpdateUserProfile"] | null> {
  return new Promise((resolve, reject) => {
    const REQUEST = gql`
      mutation adminUpdateUserProfile(
        $userId: ID!
        $profileParams: UserProfileInput
      ) {
        adminUpdateUserProfile(userId: $userId, profileParams: $profileParams) {
          legalName
          firstName
          lastName
          address1
          address2
          city
          state
          postalCode
          phoneNumber
          email
        }
      }
    `;
    const result = client.mutate<
      AdminUpdateUserProfileMutation,
      AdminUpdateUserProfileMutationVariables
    >({
      mutation: REQUEST,
      variables: { userId, profileParams },
    });
    result.then(
      (response) => {
        resolve(response.data?.adminUpdateUserProfile ?? null);
      },
      (error: Error) => {
        reject(error);
      }
    );
  });
}

export const adminService = {
  submitKYBUser,
  updateCompanyKYBInfo,
  getApprovalRequest,
  setApproval,
  getAllCompanies,
  getComplianceReports,
  getTakeRateForCompany,
  getCompany,
  getUserReviewDocuments,
  requirePortfolioUpdateRequest,
  enableFeatureForCompany,
  getEmployerGroupsByCompanyIdRequest,
  uploadEmployeesDocumentForEmployerRequest,
  getProductFeatures,
  enableFeaturesForCompany,
  getOrgForCompany,
  removeCompanyMember,
  disableCompanyRequest,
  enableCompanyRequest,
  getCompanyKybData,
  getKybStatusForCompany,
  submitKYBBusinessDocuments,
  getPricingSheet,
  getBillingDetailsForCompany,
  createInvoiceForCompany,
  getPendingAndLinkedEmployers,
  liquidateUserAccount,
  resetUserState,
  partiallyDisburseUserAccount,
  getPayrolls,
  reopenUserAccount,
  getEntityLimitsRequest,
  updateEntityLimitRequest,
  getEmployerCrmLinkRequest,
  linkEmployerToCrmRequest,
  unlinkEmployerToCrmRequest,
  syncCrmRequest,
  getAllUnprocessedPayrollsRequest,
  updateBillingType,
  getWorkflows,
  getLastWorkflowStep,
  getReportTypes,
  getCustomReports,
  approvePayrollIntegrationSetup,
  updateBillingContact,
  getKybStatus,
  migrateEmployeesForCompany,
  getEmployerOrders,
  getUserRollovers,
  paychexUsersReport,
  getSecurityDetailsRequest,
  freezeEmployer,
  unfreezeEmployer,
  getPaychexUsers,
  advanceYellowPathJourneyRequest,
  requestMemberFieldEdit,
  requestBusinessRegistrationUpdate,
  updateUserEmail,
  updateUserKyc,
  getAlloyApplication,
};
